const contexts = {};

export const log = (contextName) => {
  if (contexts[contextName]) {
    return contexts[contextName];
  }

  contexts[contextName] = new Proxy(
    {},
    {
      get: (target, property) => {
        return (...args) => {
          args.unshift(`[${contextName}]`);

          window.console[property](...args);
        };
      },
    }
  );

  return contexts[contextName];
};
